import PropTypes from "prop-types";
import TeacherManager from "./TeacherManager";
import { editInstituteTeacher, softDeleteTeacher, submitInstituteTeacher } from "firestoreService";

const InstituteTeachers = ({ data, reload }) => (
  <TeacherManager
    label="Institute teacher"
    data={data}
    reload={reload}
    onCreate={submitInstituteTeacher}
    onUpdate={editInstituteTeacher}
    onSoftDelete={softDeleteTeacher}
  />
);

InstituteTeachers.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  reload: PropTypes.func.isRequired,
};

export default InstituteTeachers;
